module.exports = __webpack_public_path__ + "img/ovkasten_ls_ms.9fb86475.png";